<div class="modal-header d-flex  justify-content-between">
    <h5 class="modal-title">Rediger ordre</h5>

    <div class="d-flex  justify-content-between gap-1">
        <!--    <button (click)="copy()" type="button" class="btn btn-primary" [disabled]="saving">Kopier til dellevering</button>-->
        <button (click)="save()" type="button" class="btn  btn-primary"
                [disabled]="saving">{{ saving ? 'Gemmer...' : 'Gem og luk' }}</button>
        <button (click)="close()" type="button" class="btn  btn-secondary" data-dismiss="modal" [disabled]="saving"><span
                i18n>Close</span></button>
       <!-- <button (click)="close()" type="button" class="btn btn-sm btn-danger" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button> -->
    </div>
</div>

<div class="modal-body">

    <ng-container *ngIf="showAddress && _shipment && _shipment.shipment_addresses">
        <app-edit-adresses-form [_shipment]="_shipment" [simple]="simple" (stuffChanged)="save()"></app-edit-adresses-form>
    </ng-container>
    <div *ngIf="showDriver">
        <p *ngIf="!shipmentRoutes" class="text-muted">Indlæser ...</p>
        <div *ngIf="shipmentRoutes">
            <app-shipment-edit-form
                    [parentModal]="modal"
                    [simple]="simple"
                    [_shipment]="_shipment" [shipmentRoutes]="shipmentRoutes" (stuffChanged)="updateChanges()">></app-shipment-edit-form>
        </div>
    </div>
</div>

<div class="modal-footer"></div>
